module.exports = __webpack_public_path__ + "assets/img/LTC015.241706de.png";